import styled from "@emotion/styled";

const SectionWrapper = styled.div`
  /* background-color: #0a2f42; */
  padding-top: ${(props) => (props.pt ? props.pt : "110px")};
  padding-bottom: ${(props) => (props.pb ? props.pb : "50px")};
  margin: ${(props) => (props.m ? props.m : "0")};
  position: relative;
  display: flex;
  align-items: center;
  @media screen and (max-width: 900px) {
    min-height: unset;
    min-height: ${(props) => (props.mh900px ? props.mh900px : "")};
  }
  @media screen and (max-width: 650px) {
    min-height: ${(props) => (props.mh ? props.mh : "")};

    padding-top: ${(props) => (props.pt650px ? props.pt650px : "")};
    padding-bottom: ${(props) => (props.pb650px ? props.pb650px : "")};
  }
  @media screen and (max-width: 410px) {
    min-height: ${(props) => (props.mh410 ? props.mh410 : "")};
  }
`;
const P = styled.p`
  font-size: ${(props) => (props.fs ? props.fs : "16px")};
  font-family: "poppins-light";

  font-weight: ${(props) => (props.fw ? props.fw : "600")};
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-top: ${(props) => (props.mt ? props.mt : "20px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "20px")};
  margin-left: ${(props) => (props.ml ? props.ml : "0px")};
  margin-right: ${(props) => (props.mr ? props.mr : "0px")};

  @media (max-width: 1250px) {
    font-size: ${(props) => (props.fs1250 ? props.fs1250 : "")};
  }
  @media (max-width: 899px) {
    line-height: 24px;
    max-width: ${(props) => (props.maxWidth899 ? props.maxWidth899 : "100%")};
    margin-left: ${(props) => (props.ml599 ? props.ml599 : "0px")};
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
  @media (max-height: 700px) {
    text-align: ${(props) => (props.align700 ? props.align700 : "")};
    font-size: 14px;
  }
`;

const SectionHeading = styled.h2`
  color: #ffffff;
  display: inline-block;
  font-family: "Halloween" !important;
  font-size: ${(props) => (props.fs ? props.fs : "100px")};
  margin-top: ${(props) => (props.mt ? props.mt : "70px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "30px")};

  @media (max-width: 1260px) {
    font-size: 90px;
  }
  @media (max-width: 899px) {
    margin-top: 30px;
    font-size: 90px;
  }
  @media (max-width: 599px) {
    margin-top: 160px;
    font-size: 52px;
  }
`;
const SectionSubHeading = styled.h3`
  font-family: "poppins-Bold";
  color: #ffffff;
  font-size: ${(props) => (props.fs ? props.fs : "50px")};
  margin-top: ${(props) => (props.mt ? props.mt : "70px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "30px")};
  text-align: ${(props) => (props.tc ? props.tc : "")};

  @media (max-width: 899px) {
    text-align: ${(props) => (props.align ? props.align : "")};
  }
  @media (max-width: 599px) {
    margin-top: ${(props) => (props.mt599 ? props.mt599 : "")};
    font-size: 30px;
  }
`;
const SectionSmallHeading = styled.h4`
  padding-top: 0;
  margin-top: ${(props) => (props.mt ? props.mt : "30px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "10px")};
  font-size: ${(props) => (props.fs ? props.fs : "21px")};
  text-align: ${(props) => (props.tc ? props.tc : "")};
  font-family: "poppins-light";
  color: #ffffff;
  @media (max-width: 899px) {
    font-size: 30px;
  }
  @media (max-width: 599px) {
    font-size: 25px;
  }
`;
const Box = styled.div`
  text-align: ${(props) => (props.align ? props.align : "")};
  background: rgba(36, 39, 42, 0.8);
  backdrop-filter: blur(9.5px);
  -webkit-backdrop-filter: blur(9.5px);
  /* display: flex;
  justify-content: center; */
  display: ${(props) => (props.display ? props.display : "")};
  min-height: ${(props) => (props.minheight ? props.minheight : "")};
  padding: ${(props) => (props.padding ? props.padding : "30px")};
  /* min-height: 220px; */
  padding-left: ${(props) => (props.pl ? props.pl : "")};
  margin-top: ${(props) => (props.mt ? props.mt : "40px")};
  @media screen and (max-width: 1240px) {
    min-height: ${(props) => (props.minh ? props.minh : "")};
  }
  @media screen and (max-width: 899px) {
    /* padding-left: ${(props) => (props.pl899px ? props.pl899px : "10px")}; */
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.padding599 ? props.padding599 : "")};
    max-width: 100%;
    min-height: ${(props) => (props.mh ? props.mh : "")};
  }
`;
export {
  SectionSmallHeading,
  SectionWrapper,
  P,
  SectionHeading,
  SectionSubHeading,
  Box,
};
